// @flow
import React, { PureComponent } from 'react';
import SaveSearch from '../SaveSearch/SaveSearch';
import JobMailWrapper from '../JobMail/JobMailWrapper';

type Props = {
  authenticated: boolean,
  position: JobMailPosition
};

class SavePanel extends PureComponent<Props> {
  props: Props;

  render() {
    const { position, authenticated } = this.props;

    if (!authenticated) {
      return <JobMailWrapper position={position} />;
    }

    return position === 'top' && <SaveSearch />;
  }
}

export default SavePanel;
